
import { defineComponent, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import Trim from "@/javascripts/image/trim";
import EnterButton from "@/components/EnterButton.vue";
import CancelButton from "@/components/CancelButton.vue";
import Header from "@/components/Header.vue";

export default defineComponent({
  name: "Trim",
  components: {
    EnterButton,
    CancelButton,
    Header,
  },
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });
    const toEdit = () => router.push({ name: "edit" });

    const trim = new Trim();

    const { imageEditor } = useGlobalStore();
    const selectedImage = imageEditor.selectedImage;
    if (!selectedImage) {
      toSelect();
      return;
    }
    let canvasImgSrc = "";
    if (imageEditor.isSelectedImageUploaded()) {
      canvasImgSrc = selectedImage.src as string;
    } else {
      const canvasImgName = selectedImage.fileName;
      canvasImgSrc = "/app/assets/img/base_illust/original/" + canvasImgName;
    }

    onMounted(() => {
      trim.setupView();
    });

    onUnmounted(() => {});

    /**
     * 完了ボタン押下時の処理
     */
    function onClickCompleteBtn() {
      trim.barragePreventAll();
      trimImage();
      toEdit();
    }

    function trimImage() {
      const points = trim.getTrimmingAreaBottomPoints();
      const scale = trim.getTrimmingScale();
      const trimPoint = { x: points.x, y: points.y, scale: scale };
      imageEditor.trimImage(trimPoint);
    }

    return {
      toSelect,
      onClickCompleteBtn,
      canvasImgSrc,
    };
  },
});
